import { Booking } from 'types';
import { BookingActivity } from 'types/audit/booking-activity';
import { fetchPaginated } from './fetch-paginated';
import fetchWithRetry from './fetch-retry';

export const fetchBookingsList = fetchPaginated<Booking>('bookings');

export const getBookingById = async (id: number): Promise<Booking | null> =>
  await fetchWithRetry(`/api/bookings/${id}`, { method: 'GET' }, null);

export const getBookingByUnitId = async (unitId: number): Promise<Booking | null> =>
  await fetchWithRetry(`/api/bookings/units/${unitId}`, { method: 'GET' }, null);

export const getBookingByNumber = async (
  input: string,
  customerId?: number,
  locationId?: number
): Promise<Booking | null> => {
  const url = new URL('/api/bookings', window.location.origin);
  url.searchParams.append('bookingNumber', encodeURIComponent(input));
  if (customerId) url.searchParams.append('customerId', `${customerId}`);
  if (locationId) url.searchParams.append('locationId', `${locationId}`);
  return await fetchWithRetry<Booking | null>(url, { method: 'GET' }, null);
};

// export const postBooking = async (booking: Booking): Promise<Booking | null> => {
//   const init: RequestInit = {
//     method: 'POST',
//     headers: new Headers({ 'Content-Type': 'application/json' }),
//     body: JSON.stringify(booking)
//   };

//   return await fetchWithRetry('/api/bookings', init, null);
// };

// export const updateBooking = async (booking: Booking): Promise<Booking | null> => {
//   const init: RequestInit = {
//     method: 'PUT',
//     headers: new Headers({ 'Content-Type': 'application/json' }),
//     body: JSON.stringify(booking)
//   };

//   return await fetchWithRetry(`/api/bookings/${booking.id}`, init, null);
// };

// export const reserveUnit = async (id: number, unit: Partial<ActiveUnit>): Promise<Booking | null> => {
//   const init: RequestInit = {
//     method: 'PUT',
//     headers: new Headers({ 'Content-Type': 'application/json' }),
//     body: JSON.stringify(unit)
//   };

//   return await fetchWithRetry(`/api/bookings/${id}/units`, init, null);
// };

// export const removeUnit = async (bookingId: number, unitId: number): Promise<Booking | null> => {
//   return await fetchWithRetry(`/api/bookings/${bookingId}/units/${unitId}`, { method: 'DELETE' }, null);
// };

export const deleteBooking = async (id: number): Promise<void> =>
  await fetchWithRetry<void>(`/api/bookings/${id}`, { method: 'DELETE' }, (() => {})());

export const getBookingActivity = async (id: number): Promise<BookingActivity[]> => {
  const url = new URL(`/api/bookings/${id}/activity`, window.location.origin);
  return await fetchWithRetry<BookingActivity[]>(url, { method: 'GET' }, []);
};
